import { App } from "antd";

export function useApp() {
  const params = App.useApp();

  return params;
}
